
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, MenuItem, TextField } from "@mui/material";
import { useBodegasQuery, useCentroCostoSelect, useInventarioSinPaginarXBodega } from "../../../../hooks";
import { startTrasladoBodegas } from "../../../../services";

import Swal from "sweetalert2";




export const FormTransladoBodegas = () => {


    const { id } = useParams();
    const { inventarioSinPaginar } = useInventarioSinPaginarXBodega(id);
    const { bodegasListQuery } = useBodegasQuery();
    const { data } = useCentroCostoSelect();
    const [formValues, setFormValues] = useState({ producto: '', para: '',  cantidad: '', tipo: '', });
    const { producto, para, cantidad, tipo } = formValues;



    const handleChanges = ({ target: { name, value } }) => {
        setFormValues(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'tipo' ? { para: '' } : {})
        }));
    };


    
    const handleGenerarTranslado = async(e) => {
        e.preventDefault();
        if([producto, para, cantidad].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }

        await Swal.fire({
            title: `Realizar Traslado`,
            text: `¿Esta seguro de realizar este traslado?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, realizar`
        }).then( async( _ ) => {
            const resp = await startTrasladoBodegas({...formValues, de: id});
            if(resp){
                setFormValues({ producto: '', para: '',  cantidad: '', tipo: '' })
            }
        });
    }




    return (

        <form onSubmit={ handleGenerarTranslado } >
            <Grid container spacing={2} my={3}>

                <Grid item xs={12}>
                    <TextField required
                    select
                    size="small"
                    label="Tipo de Envio"
                    fullWidth
                    name='tipo'
                    value={tipo}
                    onChange={ handleChanges }
                >
                        <MenuItem value=''>Seleccione Tipo de Envio</MenuItem>
                        <MenuItem value='TRASLADO'>TRASLADO</MenuItem>
                        <MenuItem value='CENTRO-COSTO'>CENTRO-COSTO</MenuItem>
                    </TextField>
                </Grid>


                <Grid item xs={12}>
                    <Autocomplete fullWidth size="small"
                        options={inventarioSinPaginar?.data || []}
                        getOptionLabel={(option) => option?.producto.nombre || ''}
                        value={inventarioSinPaginar.data?.find(valor => valor.producto._id == producto) || null}
                        onChange={(_, newValue) => {
                            handleChanges({
                                target: { name: 'producto', value: newValue ? newValue.producto._id : '' }
                            });
                        }}
                        renderOption={(props, option, { index }) => (
                            <li {...props} key={`${option.id}-${index}`}>
                            {option.producto.nombre}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione Producto" required name="producto" />
                        )}
                    />
                </Grid>

                {(tipo === 'TRASLADO') &&
                    <Grid item xs={12}>
                        <TextField required
                            size="small"
                            select
                            label="Seleccione Bodega"
                            fullWidth
                            name="para"
                            value={ para }
                            onChange={ handleChanges }
                        >
                            <MenuItem value=''> Seleccione Bodega</MenuItem>
                            {bodegasListQuery.data?.filter( item => item.id !== id).map( e => (
                                <MenuItem key={ e.id } value={ e.id } >{ e.nombre }</MenuItem>
                            ))}
                        </TextField>
                    </Grid> 
                }


                {(tipo === 'CENTRO-COSTO') &&
                    <Grid item xs={12}>
                        <TextField required
                            size="small"
                            select
                            label="Seleccione Centro de Costo"
                            fullWidth
                            name="para"
                            value={ para }
                            onChange={ handleChanges }
                        >
                            <MenuItem value=''> Seleccione Centro de Costo</MenuItem>
                            {data.map( e => (
                                <MenuItem key={ e._id } value={ e._id } >{ e.nombre }</MenuItem>
                            ))}
                        </TextField>
                    </Grid> 
                }

                <Grid item xs={12}>
                    <TextField 
                        type="number"
                        label='Cantidad'
                        fullWidth
                        size="small"
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleChanges }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={12} sm={8}>
                    <Button variant='contained' fullWidth type='submit'>
                        Crear Translado
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
